module.exports = __webpack_public_path__ + "img/15.a604a3c6.png";